/**
 * PURPOSE: Provide reducers that are not required for the initial boostrap of the application.  For the bootstrap related reducers
 *   take a look at `initialReducers.ts`.
 */

// externals
import type { AnyAction, Reducer } from 'redux';

// libraries
import * as accessoriesReducer from '@makemydeal/dr-dash-store/reducers/accessoriesReducer';
import * as activityMilestoneReducer from '@makemydeal/dr-dash-store/reducers/activityMilestoneReducer';
import * as baseDealReducer from '@makemydeal/dr-dash-store/reducers/baseDealReducer';
import * as manualFieldOverridesReducer from '@makemydeal/dr-dash-store/reducers/manualFieldOverridesReducer';
import * as calculationDetailsReducer from '@makemydeal/dr-dash-store/reducers/calculationDetailsReducer';
import * as comparisonReducer from '@makemydeal/dr-dash-store/reducers/comparisonReducer';
import * as connectionReducer from '@makemydeal/dr-dash-store/reducers/connectionReducer';
import * as consumerInsightsReducer from '@makemydeal/dr-dash-store/reducers/consumerInsightsReducer';
import * as purchaseHistoryReducer from '@makemydeal/dr-dash-store/reducers/purchaseHistoryReducer';
import * as tradeInIntelligenceReducer from '@makemydeal/dr-dash-store/reducers/tradeInIntelligenceReducer';
import * as openRepairOrdersReducer from '@makemydeal/dr-dash-store/reducers/openRepairOrdersReducer';
import * as contractingReducer from '@makemydeal/dr-dash-store/reducers/contractingReducer';
import * as creditAppReducer from '@makemydeal/dr-dash-store/reducers/creditAppReducer';
import * as creditAppSearchReducer from '@makemydeal/dr-dash-store/reducers/creditAppSearchReducer';
import * as creditDecisionReducer from '@makemydeal/dr-dash-store/reducers/creditDecisionReducer';
import * as customerSpdReducer from '@makemydeal/dr-dash-store/reducers/customerSpdReducer';
import * as customerUIReducer from '@makemydeal/dr-dash-store/reducers/customerUIReducer';
import * as dashBootstrapReducer from '@makemydeal/dr-dash-store/reducers/bootstrapReducer';
import * as dealAuditLogReducer from '@makemydeal/dr-dash-store/reducers/dealAuditLogReducer';
import * as dealerReducer from '@makemydeal/dr-dash-store/reducers/dealerReducer';
import * as dealHistoryReducer from '@makemydeal/dr-dash-store/reducers/dealHistoryReducer';
import * as dealLifecycleReducer from '@makemydeal/dr-dash-store/reducers/dealLifecycleReducer';
import * as docMoveReducer from '@makemydeal/dr-dash-store/reducers/docMoveReducer';
import * as dealModeReducer from '@makemydeal/dr-dash-store/reducers/dealModeReducer';
import * as dealScreenErrorReducer from '@makemydeal/dr-dash-store/reducers/dealScreenErrorReducer';
import * as dealSpdReducer from '@makemydeal/dr-dash-store/reducers/dealSpdReducer';
import * as dealTemplateReducer from '@makemydeal/dr-dash-store/reducers/dealTemplateReducer';
import * as dealValidationReducer from '@makemydeal/dr-dash-store/reducers/dealValidationReducer';
import * as dealXgDetailsReducer from '@makemydeal/dr-dash-store/reducers/dealXgDetailsReducer';
import * as deskingGlobalReducer from '@makemydeal/dr-dash-store/reducers/deskingGlobalReducer';
import * as deskingReducer from '@makemydeal/dr-dash-store/reducers/deskingReducer';
import * as docUploadReducer from '@makemydeal/dr-dash-store/reducers/docUploadReducer';
import * as firstPencilReducer from '@makemydeal/dr-dash-store/reducers/firstPencilReducer';
import * as dueAtSigningReducer from '@makemydeal/dr-dash-store/reducers/dueAtSigningReducer';
import * as editCustomerReducer from '@makemydeal/dr-dash-store/reducers/editCustomerReducer';
import * as employeeDetailsReducer from '@makemydeal/dr-dash-store/reducers/employeeDetailsReducer';
import * as internalPrevOfferReducer from '@makemydeal/dr-dash-store/reducers/internalPrevOfferReducer';
import * as leadReducer from '@makemydeal/dr-dash-store/reducers/leadReducer';
import * as lenderAddressReducer from '@makemydeal/dr-dash-store/reducers/lenderAddressReducer';
import * as lenderListReducer from '@makemydeal/dr-dash-store/reducers/lenderListReducer';
import * as networkReducer from '@makemydeal/dr-dash-store/reducers/networkReducer';
import * as offerInfoReducer from '@makemydeal/dr-dash-store/reducers/offerInfoReducer';
import * as paymentFeesTypesReducer from '@makemydeal/dr-dash-store/reducers/paymentFeesTypesReducer';
import * as piiConsistencyReducer from '@makemydeal/dr-dash-store/reducers/piiConsistencyReducer';
import * as printPdfReducer from '@makemydeal/dr-dash-store/reducers/printPdfReducer';
import * as programsReducer from '@makemydeal/dr-dash-store/reducers/programsReducer';
import * as programsPreferencesReducer from '@makemydeal/dr-dash-store/reducers/programsPreferencesReducer';
import * as proposalReducer from '@makemydeal/dr-dash-store/reducers/proposalReducer';
import * as pushToDarwinReducer from '@makemydeal/dr-dash-store/reducers/pushToDarwinReducer';
import * as pushToDmsReducer from '@makemydeal/dr-dash-store/reducers/pushToDmsReducer';
import * as pushToFIReducer from '@makemydeal/dr-dash-store/reducers/pushToFIReducer';
import * as pushToRouteOneReducer from '@makemydeal/dr-dash-store/reducers/pushToRouteOneReducer';
import * as quickCompareReducer from '@makemydeal/dr-dash-store/reducers/quickCompareReducer';
import * as rateTypeReducer from '@makemydeal/dr-dash-store/reducers/rateTypeReducer';
import * as resendIdVerificationReducer from '@makemydeal/dr-dash-store/reducers/resendIdVerificationReducer';
import * as reservationReducer from '@makemydeal/dr-dash-store/reducers/reservationReducer';
import * as rollbackReducer from '@makemydeal/dr-dash-store/reducers/rollbackReducer';
import * as rollbackTradeInReducer from '@makemydeal/dr-dash-store/reducers/rollbackTradeInReducer';
import * as rollToOptionsReducer from '@makemydeal/dr-dash-store/reducers/rollToOptionsReducer';
import * as shopperNotificationsReducer from '@makemydeal/dr-dash-store/reducers/shopperNotificationsReducer';
import * as testDriveReducer from '@makemydeal/dr-dash-store/reducers/testDriveReducer';
import * as tradeInCardReducer from '@makemydeal/dr-dash-store/reducers/tradeInCardReducer';
import * as tradeInReducer from '@makemydeal/dr-dash-store/reducers/tradeInReducer';
import * as tradeInsReducer from '@makemydeal/dr-dash-store/reducers/tradeInsReducer';
import * as tradeInsScopedReducer from '@makemydeal/dr-dash-store/reducers/tradeInsScopedReducer';
import * as tradeReconCostReducer from '@makemydeal/dr-dash-store/reducers/tradeReconCostReducer';
import * as vAutoReducer from '@makemydeal/dr-dash-store/reducers/vAutoReducer';
import * as vAutoTriforceReducer from '@makemydeal/dr-dash-store/reducers/vAutoTriforceReducer';
import * as vehicleProtectionReducer from '@makemydeal/dr-dash-store/reducers/vehicleProtectionReducer';
import * as vehicleReducer from '@makemydeal/dr-dash-store/reducers/vehicleReducer';
import * as baggageFuelEconomyReducer from '@makemydeal/dr-dash-store/reducers/baggageFuelEconomyReducer';
import * as leaseContractingFieldsReducer from '@makemydeal/dr-dash-store/reducers/leaseContractingFieldsReducer';
import * as incompleteTradeModalReducer from '@makemydeal/dr-dash-store/reducers/incompleteTradeModalReducer';
import * as dealershipsReducer from '@makemydeal/dr-dash-store/reducers/dealershipsReducer';
import * as incentivesReducer from '@makemydeal/dr-dash-store/reducers/incentivesReducer';
import * as reportIssueReducer from '@makemydeal/dr-dash-store/reducers/reportIssueReducer';
import * as saveValidationReducer from '@makemydeal/dr-dash-store/reducers/saveValidationReducer';
import * as altDealStructureReducer from '@makemydeal/dr-dash-store/reducers/altDealStructureReducer';
import * as avoReducer from '@makemydeal/dr-dash-store/reducers/avoReducer';
import * as globalPrintingSettingsReducer from '@makemydeal/dr-dash-store/reducers/globalPrintingSettingsReducer';
import type { FlexBuyPaymentReducer, paymentTypes } from '@makemydeal/dr-offer-redux';
import {
    configureReducer as configureOfferReducer,
    flexBuyPaymentReducer,
    rootReducer as offerReducer,
    paymentReducer
} from '@makemydeal/dr-offer-redux';
import { type Offer, type OfferType, ApplicationCodes } from '@makemydeal/dr-platform-types';
import type { InitContext } from '@makemydeal/dr-shared-store';
import { bridgeUserReducer } from '@makemydeal/dr-shared-store';

// config
import { changeVehicleConfiguration } from '../activities/change-vehicle';
import { fuelSavingConfiguration } from '../activities/fuel-saving';
import { openDealConfiguration } from '../activities/open-deal-dashboard';
import { roleAssumptionConfiguration } from '../activities/role-assumption';
import { recentDealsConfiguration } from '../activities/recent-deals';

import type { TradeReducer } from '../activities/trade';
import { tradeConfiguration } from '../activities/trade';

// utils
import { shouldRevertPaymentOnFailure } from './utils/offerPaymentReverter';

// types
import type { ChangeVehicleReducer } from '@makemydeal/dr-activities-change-vehicle';
import type { DealershipPickerReducer } from '@makemydeal/dr-activities-dealership-picker';
import type { FuelSavingReducer } from '@makemydeal/dr-activities-fuel-saving';
import type { OpenDealReducer } from '@makemydeal/dr-activities-open-deal-v2';
import type { RoleAssumptionReducer } from '@makemydeal/dr-activities-role-assumption';
import type { RecentDealsReducer } from '@makemydeal/dr-activities-recent-deals';
import { dealershipPickerConfiguration } from '../activities/dealership-picker';
import { customerCardConfiguration, activitiesCustomerSpdReducer } from '../activities/customer-card';
import type {
    CustomerCardReducer,
    CustomerSpdReducer as ActivitiesCustomerSpdReducer
} from '@makemydeal/dr-activities-customer-card';

export type OfferReducer = Reducer<Offer>;

export type PaymentReducer = Reducer<any>;

export type RemainingReducers = {
    accessories: accessoriesReducer.AccessoriesReducer;
    activityMilestones: activityMilestoneReducer.ActivityMilestoneReducer;
    baseDeal?: baseDealReducer.BaseDealReducer;
    manualFieldOverrides: manualFieldOverridesReducer.ManualFieldOverridesReducer;
    bootstrap: dashBootstrapReducer.BootstrapReducer;
    bridgeUser: bridgeUserReducer.BridgeUserReducer;
    calculationDetails: calculationDetailsReducer.CalculationDetailsReducer;
    changeVehicle: ChangeVehicleReducer;
    openDeal: OpenDealReducer;
    dealershipPicker: DealershipPickerReducer;
    comparison: comparisonReducer.ComparisonReducer;
    connection: connectionReducer.ConnectionReducer;
    consumerInsights: consumerInsightsReducer.ConsumerInsightsReducer;
    purchaseHistory: purchaseHistoryReducer.PurchaseHistoryReducer;
    tradeInIntelligence: tradeInIntelligenceReducer.TradeInIntelligenceReducer;
    openRepairOrders: openRepairOrdersReducer.OpenRepairOrdersReducer;
    contracting: contractingReducer.ContractingReducer;
    creditApp: creditAppReducer.CreditAppReducer;
    creditAppSearch: creditAppSearchReducer.CreditAppSearchReducer;
    creditDecision: creditDecisionReducer.CreditDecisionReducer;
    customerUI: customerUIReducer.CustomerUIReducer;
    dealer: dealerReducer.DealerReducer;
    dealHistory: dealHistoryReducer.DealHistoryReducer;
    dealLifecycle: dealLifecycleReducer.DealLifecycleReducer;
    dealValidation: dealValidationReducer.DealValidationReducer;
    dealXgDetails: dealXgDetailsReducer.DealXgDetailsReducer;
    fuelSaving: FuelSavingReducer;
    desking: deskingReducer.DeskingReducer;
    deskingGlobal: deskingGlobalReducer.DeskingGlobalReducer;
    docUpload: docUploadReducer.DocUploadReducer;
    firstPencil: firstPencilReducer.FirstPencilReducer;
    employeeDetails: employeeDetailsReducer.EmployeeDetailsReducer;
    internalPrevOffer: internalPrevOfferReducer.InternalPrevOfferReducer;
    lead: leadReducer.LeadReducer;
    lenderAddress: lenderAddressReducer.LenderAddressReducer;
    lenderList: lenderListReducer.LenderListReducer;
    network: networkReducer.NetworkReducer;
    offer: OfferReducer;
    offerInfo?: offerInfoReducer.OfferInfoReducer;
    payment: PaymentReducer;
    printPdf: printPdfReducer.PrintPdfReducer;
    programs?: programsReducer.ProgramsReducer;
    programsPreferences?: programsPreferencesReducer.ProgramsPreferencesReducer;
    pushToDarwin: pushToDarwinReducer.PushToDarwinReducer;
    pushToDms: pushToDmsReducer.PushToDmsReducer;
    docMove: docMoveReducer.DocMoveReducer;
    pushToFI: pushToFIReducer.PushToFIReducer;
    pushToRouteOne: pushToRouteOneReducer.PushToRouteOneReducer;
    quickCompare: quickCompareReducer.QuickCompareReducer;
    reservation: reservationReducer.ReservationReducer;
    rollback: rollbackReducer.RollbackReducer;
    rollbackTradeIn: rollbackTradeInReducer.RollbackTradeInReducer;
    rollToOptions: rollToOptionsReducer.RollToOptionsReducer;
    shopperNotifications: shopperNotificationsReducer.ShopperNotificationsReducer;
    testDrive: testDriveReducer.TestDriveReducer;
    tradeIn: tradeInReducer.TradeInReducer;
    tradeInCard: tradeInCardReducer.TradeInCardReducer;
    tradeInComponent?: TradeReducer;
    tradeInsScoped?: tradeInsScopedReducer.TradeInsScopedReducer;
    tradeReconCostConfig?: tradeReconCostReducer.TradeReconCostScopedReducer;
    vAuto?: vAutoReducer.vAutoReducer;
    vAutoTriforce?: vAutoTriforceReducer.vAutoTriforceReducer;
    vehicle: vehicleReducer.VehicleReducer;
    vehicleProtectionV2?: vehicleProtectionReducer.VehicleProtectionReducer;
    dealTemplates: dealTemplateReducer.DealTemplateReducer;
    flexBuyPayments: FlexBuyPaymentReducer;
    dealMode: dealModeReducer.DealModeReducer;
    rateType: rateTypeReducer.RateTypeReducer;
    editCustomerSlideout: editCustomerReducer.editCustomerReducer;
    dealAuditLog: dealAuditLogReducer.AuditLogReducer;
    dealSpd: dealSpdReducer.DealSpdReducer;
    dueAtSigning: dueAtSigningReducer.DueAtSigningReducer;
    dealScreenError: dealScreenErrorReducer.DealScreenErrorReducer;
    customerSpd: customerSpdReducer.CustomerSpdReducer;
    piiConsistency: piiConsistencyReducer.PIIConsistencyReducer;
    resendIdVerification: resendIdVerificationReducer.ResendIdVerificationReducer;
    proposal: proposalReducer.ProposalReducer;
    tradeIns?: tradeInsReducer.TradeInsReducer;
    leaseContractingFields?: leaseContractingFieldsReducer.LeaseContractingFieldsReducer;
    roleAssumption: RoleAssumptionReducer;
    recentDeals: RecentDealsReducer;
    dealerships: dealershipsReducer.DealershipsReducer;
    incentiveValidation: incentivesReducer.IncentiveValidationReducer;
    baggageFuelEconomy?: baggageFuelEconomyReducer.BaggageFuelEconomyReducer;
    incompleteTradeModal?: incompleteTradeModalReducer.IncompleteTradeModalReducer;
    reportIssue: reportIssueReducer.ReportIssueReducer;
    saveValidation: saveValidationReducer.SaveValidationReducer;
    altDealStructure: altDealStructureReducer.AltDealStructureReducer;
    aiVehicleRecommendationsStale: avoReducer.AvoReducer;
    globalPrintingSettings: globalPrintingSettingsReducer.GlobalPrintingSettingsReducer;
    customerCard?: CustomerCardReducer;
    activitiesCustomerSpd?: ActivitiesCustomerSpdReducer;
};
export const paymentOfferAndDashReducers = (state = {}, action: AnyAction) => {
    const paymentState = paymentReducer(state as paymentTypes.PaymentState, action);
    const internalAndOfferPaymentState = paymentFeesTypesReducer.reducer(paymentState, action);

    return internalAndOfferPaymentState;
};

const configureOfferReducerForMenuActivity = () => {
    const offerReducerConfig = {
        sourceApplication: ApplicationCodes.MV,
        selectors: {
            shouldRevertPaymentOnFailure: (state: any, action: any, offerType: OfferType): boolean =>
                shouldRevertPaymentOnFailure(state, action, offerType)
        }
    };
    configureOfferReducer(offerReducerConfig);
};

/**
 * Retrieve global reducers that aren't needed for the initial bootstrap of the application.
 * Global Reducers represent data that is shared between all deals that could be open in parallel
 * Example: Bridge User and Dealer, they will be the same, no matter which deal is opened
 * @param _context unused; the signature is fixed by `GetRemainingReducers` in sharedBootstrapMiddleware
 * @returns object containing global reducers
 * @see {@link getScopedRemainingReducers}
 */
export const getGlobalRemainingReducers = (_context: InitContext): Partial<RemainingReducers> => {
    configureOfferReducerForMenuActivity();

    const globalReducers: Partial<RemainingReducers> = {
        bootstrap: dashBootstrapReducer.reducer,
        bridgeUser: bridgeUserReducer.reducer,
        comparison: comparisonReducer.reducer,
        contracting: contractingReducer.reducer,
        creditAppSearch: creditAppSearchReducer.reducer,
        employeeDetails: employeeDetailsReducer.reducer,
        dealer: dealerReducer.reducer,
        dealHistory: dealHistoryReducer.reducer,
        deskingGlobal: deskingGlobalReducer.reducer,
        internalPrevOffer: internalPrevOfferReducer.reducer,
        network: networkReducer.reducer,
        offerInfo: offerInfoReducer.reducer,
        // Global, not scoped: repair orders are a property of the car, so scenarios sharing a vin
        // share one cached response and only one request goes out for them.
        openRepairOrders: openRepairOrdersReducer.reducer,
        tradeInIntelligence: tradeInIntelligenceReducer.reducer,
        shopperNotifications: shopperNotificationsReducer.reducer,
        tradeIn: tradeInReducer.reducer,
        baseDeal: baseDealReducer.reducer,
        dealTemplates: dealTemplateReducer.reducer,
        dealMode: dealModeReducer.reducer,
        editCustomerSlideout: editCustomerReducer.reducer,
        dealSpd: dealSpdReducer.reducer,
        resendIdVerification: resendIdVerificationReducer.reducer,
        proposal: proposalReducer.reducer,
        dealerships: dealershipsReducer.reducer,
        incentiveValidation: incentivesReducer.incentiveValidationReducer,
        incompleteTradeModal: incompleteTradeModalReducer.reducer,
        reportIssue: reportIssueReducer.reducer,
        saveValidation: saveValidationReducer.reducer,
        tradeReconCostConfig: tradeReconCostReducer.reducer,
        globalPrintingSettings: globalPrintingSettingsReducer.reducer,
        programsPreferences: programsPreferencesReducer.reducer
    };

    globalReducers.tradeInComponent = tradeConfiguration.reducer;
    globalReducers.tradeIns = tradeInsReducer.reducer;

    return globalReducers;
};

/**
 * Retrieve reducers that aren't needed for the initial bootstrap of the application.
 * Scoped Reducers represent data that is isolated between deals that could be open in parallel
 * Example: Accessories, Offer and Vehicle Protection, since each deal will potentially have their own values for them
 * @param _context unused; the signature is fixed by `GetRemainingReducers` in sharedBootstrapMiddleware
 * @returns object containing scoped reducers
 * @see {@link getGlobalRemainingReducers}
 */
export const getScopedRemainingReducers = (_context: InitContext): Partial<RemainingReducers> => {
    configureOfferReducerForMenuActivity();

    const dealSpecificReducers: Partial<RemainingReducers> = {
        accessories: accessoriesReducer.reducer,
        activityMilestones: activityMilestoneReducer.reducer,
        calculationDetails: calculationDetailsReducer.reducer,
        manualFieldOverrides: manualFieldOverridesReducer.reducer,
        changeVehicle: changeVehicleConfiguration.reducer,
        openDeal: openDealConfiguration.reducer,
        dealershipPicker: dealershipPickerConfiguration.reducer,
        connection: connectionReducer.reducer,
        consumerInsights: consumerInsightsReducer.reducer,
        purchaseHistory: purchaseHistoryReducer.reducer,
        creditApp: creditAppReducer.reducer,
        creditDecision: creditDecisionReducer.reducer,
        customerUI: customerUIReducer.reducer,
        dealLifecycle: dealLifecycleReducer.reducer,
        dealValidation: dealValidationReducer.reducer,
        fuelSaving: fuelSavingConfiguration.reducer,
        baggageFuelEconomy: baggageFuelEconomyReducer.reducer,
        dealXgDetails: dealXgDetailsReducer.reducer,
        desking: deskingReducer.reducer,
        docUpload: docUploadReducer.reducer,
        firstPencil: firstPencilReducer.reducer,
        lead: leadReducer.reducer,
        lenderAddress: lenderAddressReducer.reducer,
        lenderList: lenderListReducer.reducer,
        offer: offerReducer,
        payment: paymentOfferAndDashReducers,
        programs: programsReducer.reducer,
        pushToDms: pushToDmsReducer.reducer,
        docMove: docMoveReducer.reducer,
        pushToDarwin: pushToDarwinReducer.reducer,
        pushToFI: pushToFIReducer.reducer,
        pushToRouteOne: pushToRouteOneReducer.reducer,
        printPdf: printPdfReducer.reducer,
        quickCompare: quickCompareReducer.reducer,
        rateType: rateTypeReducer.reducer,
        reservation: reservationReducer.reducer,
        rollback: rollbackReducer.reducer,
        rollbackTradeIn: rollbackTradeInReducer.reducer,
        rollToOptions: rollToOptionsReducer.reducer,
        dueAtSigning: dueAtSigningReducer.reducer,
        testDrive: testDriveReducer.reducer,
        vehicle: vehicleReducer.reducer,
        vAuto: vAutoReducer.reducer,
        vAutoTriforce: vAutoTriforceReducer.reducer,
        vehicleProtectionV2: vehicleProtectionReducer.reducer,
        flexBuyPayments: flexBuyPaymentReducer.reducer as FlexBuyPaymentReducer,
        dealAuditLog: dealAuditLogReducer.reducer,
        customerSpd: customerSpdReducer.reducer,
        dealScreenError: dealScreenErrorReducer.reducer,
        piiConsistency: piiConsistencyReducer.reducer,
        leaseContractingFields: leaseContractingFieldsReducer.reducer,
        roleAssumption: roleAssumptionConfiguration.reducer,
        recentDeals: recentDealsConfiguration.reducer,
        altDealStructure: altDealStructureReducer.reducer,
        aiVehicleRecommendationsStale: avoReducer.reducer,
        customerCard: customerCardConfiguration.reducer,
        activitiesCustomerSpd: activitiesCustomerSpdReducer
    };

    dealSpecificReducers.tradeInComponent = tradeConfiguration.reducer;
    dealSpecificReducers.tradeInCard = tradeInCardReducer.reducer;

    dealSpecificReducers.tradeInsScoped = tradeInsScopedReducer.reducer;

    return dealSpecificReducers;
};
